import React from 'react';
import { addFilter } from '../../common/services/navigation';
import SearchInput from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';
import DropdownTreeSelect from 'react-dropdown-tree-select';

function PublicFundedProjectsListerTopComponent({ search, filters, settings }) {

    
    let data = d => {
        return d.children.map(c => 
            (
                { 
                    checked: (search.industries && search.industries.toString().split(',').includes(c.key) ? true : false ), 
                    label: c.name, value: c.key,
                    children: c.children.map(ch => (
                        {
                            label:ch.name,
                            value: ch.key}
                        )) 
                    }));
    };

    const onChange = (currentNode, selectedNodes) => {
        addFilter(search, 'industries', currentNode.value, currentNode.checked);
    };

    let fromDate = 1976
    let toDate = new Date().getFullYear();

    let numberOfYears = toDate - fromDate;


	return (
        <div className="jip"> 
            <div className="filter__text">
                    Filter by
                </div> 

            <div className="filter-bar">


                <SearchInput search={search} settings={settings}/>	 

                {/* <DateFilterDropdown search={search} isYear={true} settings={settings} dateSpan={numberOfYears}  /> */}
            

            
            
            </div>

            <div className="filter-bar jip-industries">

                {/* <div className="filter__text">
                        Industries
                </div> */}

                    {filters && filters.taxonomyFilters 
                            && <DropdownTreeSelect 
                            name="industries" 
                            data={data(filters.taxonomyFilters.industries)} 
                            onChange={onChange} 
                            keepTreeOnSearch='false' 
                            clearSearchOnChange='true' 
                            placeholderText = 'Select Industries..'
                            />}

                </div>

            
        
        </div>
        


	);
}

// 1326

export default PublicFundedProjectsListerTopComponent;
